import { MouseEventHandler } from "react";

export type LinkIconProps = {
  destination: string;
  src: string;
  alt: string;
  width: string;
  height?: string;
  target?: string;
  className?: string;
  wrapperClass?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

export default function LinkIcon({
  destination,
  src,
  alt,
  width,
  height,
  target = "_blank",
  className,
  wrapperClass,
  onClick,
}: LinkIconProps) {
  return (
    <a
      href={destination}
      target={target}
      className={wrapperClass}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
      onClick={onClick}
    >
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        className={className}
      />
    </a>
  );
}
